import FaqsItem from 'components/marketingSite/shared/FaqsItem';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { config } from 'utils/config';
import {
  StyledContainer,
  StyledFaqs,
  StyledFooter
} from './ApplicationsFaqs.styled';

const ApplicationsFaqs: React.FC = () => {
  const { t } = useI18n('applications-landing');

  const faqs = [
    {
      active: true,
      question: t('applicationsLanding.faqs.tracking.title'),
      answer: t('applicationsLanding.faqs.tracking.desc')
    },
    {
      question: t('applicationsLanding.faqs.profile.title'),
      answer: t('applicationsLanding.faqs.profile.desc')
    }
  ];
  return (
    <StyledContainer>
      <Heading2 editorial>{t('applicationsLanding.faqs.title')}</Heading2>
      <StyledFaqs>
        {faqs?.map((faq, index) => {
          return (
            <FaqsItem
              key={index}
              question={faq.question}
              active={faq.active}
              answer={faq.answer}
            />
          );
        })}
      </StyledFaqs>
      <StyledFooter>
        <Trans
          ns="applications-landing"
          i18nKey={'applicationsLanding.faqs.footer'}
          values={{
            mailToSupport: config.supportEmail
          }}
          components={{
            mailToSupportLink: <a href={`mailto:${config.supportEmail}`} />
          }}
        />
      </StyledFooter>
    </StyledContainer>
  );
};

export default ApplicationsFaqs;
